module.exports = __webpack_public_path__ + "static/media/curious-person-with-box-svgrepo-com.e73fee04.svg";